import React, { useEffect, useRef } from 'react';
import '../styles/Porcentage.css';

const SpinnerComponent = ({ imagen, tono, porcentaje, isDocument, onClick }) => {
  const canvasRef = useRef(null);
  const degreesRef = useRef(0);
  const newDegrees = Math.round((porcentaje / 100) * 360);
  const color = tono;
  const bgcolor = "#aeaeae";

  useEffect(() => {

    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    const width = canvas.width;
    const height = canvas.height;
    let animationFrameId;

    const init = () => {
      ctx.clearRect(0, 0, width, height);
      ctx.beginPath();
      ctx.strokeStyle = bgcolor;
      ctx.lineWidth = 30;
      ctx.arc(width / 2, width / 2, 100, 0, Math.PI * 2, false);
      ctx.stroke();

      const radians = degreesRef.current * Math.PI / 180;
      ctx.beginPath();
      ctx.strokeStyle = color;
      ctx.lineWidth = 30;
      ctx.arc(width / 2, height / 2, 100, 0 - 90 * Math.PI / 180, radians - 90 * Math.PI / 180, false);
      ctx.stroke();

      ctx.fillStyle = color;
      ctx.font = "50px arial";
      const text = porcentaje.toFixed(1) + "%";
      //const text = Math.floor(degreesRef.current / 360 * 100).toFixed(1) + "%";
      const textWidth = ctx.measureText(text).width;
      ctx.fillText(text, width / 2 - textWidth / 2, height / 2 + 15);
    };

    const animate = () => {
      if (degreesRef.current === newDegrees) {
        cancelAnimationFrame(animationFrameId);
      } else {
        degreesRef.current++;
        init();
        setTimeout(() => {
          animationFrameId = requestAnimationFrame(animate);
        }, 1);
      }
    };

    animate();

    return () => {
      cancelAnimationFrame(animationFrameId);
    };
  }, [newDegrees]);

  return (

    <div className="spinner-container"  onClick={onClick}>
      <div className={isDocument ? "ods-image-document" : "ods-image"} >
        <img src={require(`../assets/imagenes/ods/${imagen}`)} className = "imagen"alt="ods-1" />
      </div>
      <div>
        <canvas ref={canvasRef} id={isDocument ? "spinner-document" : "spinner"}
          width="300" height="300"></canvas>
      </div >
    </div>



  );
};

export default SpinnerComponent;
